/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'

import {Notification} from '@scuf/common';
import {toast} from 'react-toastify'
import {formatMessage} from "./LocaleHelper";

const DEFAULT_PROPS = {
    className: "toast-notification",
    severity: "success",
    hasIcon: true,
    onDetailsClick: null,
    title: "Toast notification",
    onClose: () => {/* By default, do not perform any action on close, */
    },
}

export const showNotification = (props) => {
    const {autoClose, body, translationPropertyKey, ...newProps} = props

    if(translationPropertyKey != null) {
        newProps.title = formatMessage({id: translationPropertyKey})
    }

    const oProps = {
        ...DEFAULT_PROPS,
        ...newProps,
    };

    let toastId;
    const toastNotification = <Notification
        {...oProps}
        onCloseClick={() => {
            oProps.onClose();
            toast.dismiss(toastId)
        }}
    >
        {body == null ? null : body}
    </Notification>

    toastId = toast(toastNotification, {
        onClose: oProps.onClose(),
        autoClose: autoClose != null ? autoClose : 10000,
    })

    return {
        toastId: toastId,
    };

}